exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading__div-main{text-align:center;margin-top:13px}.loading__image{width:48px;height:38px}.loading__div-label,.loading__div-label-light{widows:311px;line-height:24px;font-size:15px;margin:auto;margin-bottom:4px;font-family:BentonSansBBVA Book}.loading__div-label-light{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/Loading.css
// module id = 465
// module chunks = 0 1 2 3 4 5 6 7 8 9 10